<template>
  <div class="vld-parent">
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="fullPage"
    ></loading>
    <div class="center">
      <img
        src="https://res.cloudinary.com/sirrus/image/upload/v1606425497/delivery/modas/assets/icone_chrgzf.png"
        class="centered"
        style="width: 100px; padding-top: 20px"
      />
      <h5>
        Empresa
        <strong> {{ this.$router.currentRoute.params.empresa }} </strong>não
        localizada 😓
        <br />
        <br />
        <div style="padding-left: 20%; padding-right: 20%">
          <input type="text" v-model="termo" placeholder="Pesquisar Empresa" />
          <button class="btn waves-effect" @click="GetEmpresas()">
            Pesquisar
          </button>
        </div>
      </h5>
    </div>
    <div class="container">
      <table class="striped">
        <tbody>
          <tr
            v-for="emp in empresas"
            :key="emp"
            @click="Pesquisar(emp.usuario_url)"
          >
            <span class="waves-effect" style="width: 100%">
              <td>
                <img
                  class="logoEmpresa"
                  :src="urlFiles + 'logos/' + emp.logo"
                />
              </td>
              <td class="tituloEmpresa">
                {{ emp.nome }}
              </td>
            </span>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import axios from "axios";
import Swal from "sweetalert2";

export default {
  name: "Erro",
  components: { Loading },
  data() {
    return {
      urlApi: this.$store.state.url,
      urlFiles: this.$store.state.url_files,
      termo: this.$router.currentRoute.params.empresa || "",
      empresas: [],
      isLoading: false,
      fullPage: true,
    };
  },
  methods: {
    Pesquisar(termo = null) {
      window.location.replace(
        this.$store.state.app_url + "" + termo || this.termo
      );
    },
    async GetEmpresas() {
      if (this.termo && this.termo.lengh < 3) return false;

      this.isLoading = true;

      await axios
        .get(this.$store.state.apiUrl + "empresa/pesquisar/" + this.termo)
        .then((res) => {
          if (res.data && res.data != null) {
            this.empresas = res.data;
            this.isLoading = false;
          } else {
            this.isLoading = false;
            Swal.fire({
              title: "Aviso",
              text: "não localizado",
              icon: "error",
              customClass: {
                confirmButton: "confirm-button-class materialize-red",
              },
            });
          }
        })
        .catch((error) => {
          this.isLoading = false;
          Swal.fire({
            title: "Aviso",
            text: "não localizado",
            icon: "error",
            customClass: {
              confirmButton: "confirm-button-class materialize-red",
            },
          });
        });
    },
  },
};
</script>

<style scoped>
.logoEmpresa {
  object-fit: cover;
  width: 80px;
  height: 80px;
}
.tituloEmpresa {
  font-size: medium;
}
</style>



// WEBPACK FOOTER //
// src/app/views/FindStoreView.vue